import NotificationManager from './notificationManager'

export const notifyUser = (title, options) => {
  if (!("Notification" in window)) {
      console.warn("This browser does not support desktop notification");
      return;
  }
  if (Notification.permission === "granted") {
      new Notification(title, options);
      
  } else if (Notification.permission !== "denied") {
      Notification.requestPermission()
          .then(permission => {
              console.log('permission', permission)
              if (permission === "granted") {
                  new Notification(title, options);
              }
          });
  }
}

/**
 * Add a notification to the notification system
 * @param {string} message - The notification message
 * @param {string} type - The notification type (info, success, warning, error)
 * @param {string} url - The notification url (optional)
 * @param {string} factory_id - The notification factory id (optional)
 * @param {string} role_id - The notification role id (optional)
 */
export const addNotification = (message, type = 'info', url = null, factory_id = null, role_id = null) => {
  NotificationManager.add({
    message,
    type,
    url,
    factory_id,
    role_id
  })
}

/**
 * Send notification to specific users via backend
 * @param {string} message - The notification message
 * @param {string} type - The notification type (info, success, warning, error)
 * @param {Array} userIds - Array of user IDs to send notification to
 * @param {string} [title] - Notification title
 * @returns {Promise} API response
 */
export const sendNotificationToUsers = async (message, type = 'info', userIds, title, factory_id, role_id) => {
  return await NotificationManager.sendToUsers({
    message,
    type,
    userIds,
    title,
    factory_id,
    role_id
  })
}

/**
 * Send notification to all users via backend
 * @param {string} message - The notification message
 * @param {string} type - The notification type (info, success, warning, error)
 * @param {string} [title] - Notification title
 * @returns {Promise} API response
 */
export const sendNotificationToAll = async (message, type = 'info', title) => {
  return await NotificationManager.sendToAll({
    message,
    type,
    title
  })
}